import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { SemenDto } from '@/services/semen-service';
import { formatDateString } from '@/utils';

import { DetailField, DetailFieldData } from '../BatchInformation';

const formatDate = (date?: string | null) =>
  date ? formatDateString(date, 'MM-dd-yyyy') : '';

export const AdditionalInformation = ({ semen }: { semen?: SemenDto }) => {
  const isAdditionalInfoFieldsEnabled = useFeatureFlag(
    'Semen_Additional_Info_Fields',
  );
  const isSemenDataPointsEnabled = useFeatureFlag('Semen_Data_Points');

  if (!isAdditionalInfoFieldsEnabled) {
    return (
      <p className="text-sm text-gray-600">
        Additional information about this semen batch will be displayed here.
      </p>
    );
  }

  const additionalFields: DetailFieldData[] = [
    { label: 'Birth Date', value: formatDate(semen?.sire?.birth) },
    ...(isSemenDataPointsEnabled
      ? [
          { label: 'TogId', value: semen?.togId },
          { label: 'Created On', value: formatDate(semen?.createdOn) },
          {
            label: 'Record Created On',
            value: formatDate(semen?.overriddenCreatedOn),
          },
          { label: 'Modified By', value: semen?.modifiedBy },
          { label: 'Modified On', value: formatDate(semen?.modifiedOn) },
        ]
      : []),
  ];

  return (
    <div className="-m-4 grid grid-cols-1 gap-x-6 gap-y-4 rounded-lg border border-gray-200 bg-white p-6 shadow-sm md:grid-cols-2 xl:grid-cols-3">
      {additionalFields.map((field) => (
        <DetailField key={field.label} {...field} />
      ))}
    </div>
  );
};
